import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/home/Hero";
import { Features } from "../components/home/Features";
import { DataSources } from "../components/home/DataSources";
import { About } from "../components/home/About";
import { TokenPlanned } from "../components/home/TokenPlanned";
import { DevTeaser } from "../components/home/DevTeaser";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = "TRACE — Solana Token Scanner & Blockchain Transparency";
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Features />
      <DataSources />
      <About />
      <TokenPlanned />
      <DevTeaser />
    </main>
  );
}
